import React, {useState} from 'react';
import {RequestVisitorDto} from "../../../../../../modules/vms/dto/RequestVisitorDto";
import {FormattedMessage, useIntl} from "react-intl";
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    Stack, List, ListItem, ListItemText
} from "@mui/material";
import FormFieldText from "../../../../../../components/FormFieldText";
import PlateNumberDialog from "../../../../../../components/PlateNumberDialog";
import KeyboardIcon from '@mui/icons-material/Keyboard';
import UploadFileButton from "../../../../../../components/buttons/UploadFileButton";
import DeleteIcon from '@mui/icons-material/Delete';
import {FileApi} from "../../../../../../modules/ftp/api/FileApi";
import {HttpStatus} from "../../../../../../modules/common/enums/HttpStatus";
import dayjs from "dayjs";
import {Formats} from "../../../../../../constants/Formats";
import {RequestVisitorAttachFile} from "../../../../../../modules/vms/dto/RequestVisitorAttachFile";
import {VisitorAttachFileClassify} from "../../../../../../modules/vms/enums/VisitorFileClassify";

export type VisitorDetailGeneralFormProps = {
    requestVisitor: RequestVisitorDto;
    messageMap: Map<string, string>;
    onChange: (name: string, value: any) => void;
};
const VisitorDetailGeneralForm: React.FC<VisitorDetailGeneralFormProps> = (props) => {
    const intl = useIntl();

    const [openPlateNumberDialog, setOpenPlateNumberDialog] = useState(false);

    const handleUpload = async (file: File, classify: string) => {
        let targetFolder = dayjs().format(Formats.DATE_SIMPLE);
        targetFolder = targetFolder.substring(0, 6) + "/" + targetFolder.substring(6, 7);
        const responseResult = await FileApi.uploadFile(targetFolder, "", file);
        if (responseResult.status === HttpStatus.SUCCESS) {
            // 更新访客对象的附件列表
            const newAttachFiles = [...props.requestVisitor.attachFilesArray];
            const newAttachFile = new RequestVisitorAttachFile();
            newAttachFile.fileId = responseResult.data;
            newAttachFile.classify = classify;
            newAttachFile.fileName = file.name;
            newAttachFiles.push(newAttachFile);
            props.onChange("attachFilesArray", newAttachFiles);
        }
    }

    const handleRemoveAttachFile = (index: number) => {
        const newAttachFiles = [...props.requestVisitor.attachFilesArray];
        newAttachFiles.splice(index, 1);
        props.onChange('attachFilesArray', newAttachFiles);
    }

    return (
        <Card>
            <PlateNumberDialog open={openPlateNumberDialog} onOk={(value) => props.onChange("plateNumber", value)}
                               onClose={() => setOpenPlateNumberDialog(false)}
                               value={props.requestVisitor.plateNumber}/>
            <CardHeader title={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_INFO'})}/>
            <CardContent>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_DRIVER_NAME"})}
                                       disabled={true}
                                       required={true} errorText={props.messageMap.get("lastName")}
                                       value={props.requestVisitor.lastName + ' ' + props.requestVisitor.firstName}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER_REQUIRED"})}
                                       required={true} errorText={props.messageMap.get("plateNumber")}
                                       value={props.requestVisitor.plateNumber}
                                       endAdornment={
                                           <IconButton color="primary" onClick={() => setOpenPlateNumberDialog(true)}>
                                               <KeyboardIcon/>
                                           </IconButton>}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl variant={'standard'} margin={'normal'}>
                            <Stack spacing={2}>
                                <UploadFileButton
                                    text={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_DRIVER_LICENSE_UPLOAD'})}
                                    onChange={(files) => {
                                        if (files) {
                                            for (let file of files) {
                                                handleUpload(file, VisitorAttachFileClassify.Enum.DriverLicense);
                                            }
                                        }
                                    }}/>
                                {props.messageMap.has("attachFileDriverLicense") ?
                                    <FormHelperText
                                        error={props.messageMap.has("attachFileDriverLicense")}>{props.messageMap.get("attachFileDriverLicense")}</FormHelperText> : null}
                            </Stack>
                        </FormControl>
                        <List>
                            {props.requestVisitor.attachFilesArray.map((item, index) => {
                                if (item.classify === VisitorAttachFileClassify.Enum.DriverLicense) {
                                    return <ListItem key={index}
                                                     secondaryAction={
                                                         <IconButton edge="end" aria-label="delete"
                                                                     onClick={() => handleRemoveAttachFile(index)}>
                                                             <DeleteIcon/>
                                                         </IconButton>
                                                     }>
                                        <ListItemText primary={item.fileName}/>
                                    </ListItem>
                                }
                            })}
                        </List>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl variant={'standard'} margin={'normal'}>
                            <Stack spacing={2}>
                                <UploadFileButton
                                    text={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_LICENSE_UPLOAD'})}
                                    onChange={(files) => {
                                        if (files) {
                                            for (let file of files) {
                                                handleUpload(file, VisitorAttachFileClassify.Enum.VehicleLicense);
                                            }
                                        }
                                    }}/>
                                {props.messageMap.has("attachFileVehicleLicense") ?
                                    <FormHelperText
                                        error={props.messageMap.has("attachFileVehicleLicense")}>{props.messageMap.get("attachFileVehicleLicense")}</FormHelperText> : null}
                            </Stack>
                        </FormControl>

                        <List>
                            {props.requestVisitor.attachFilesArray.map((item, index) => {
                                if (item.classify === VisitorAttachFileClassify.Enum.VehicleLicense) {
                                    return <ListItem key={index}
                                                     secondaryAction={
                                                         <IconButton edge="end" aria-label="delete"
                                                                     onClick={() => handleRemoveAttachFile(index)}>
                                                             <DeleteIcon/>
                                                         </IconButton>
                                                     }>
                                        <ListItemText primary={item.fileName}/>
                                    </ListItem>
                                }
                            })}
                        </List>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default VisitorDetailGeneralForm;
